import clsx from 'clsx';
import React from 'react';

import Pill from '@components/Pill';
import useEventTracking from '@hooks/useEventTracking';
import { graphics_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import { ALL, DEFAULT_POPULAR_TOPICS, PRO_FILTER, PRO_FILTER_TEXT } from '../constants';
import type { PopularTopicsProps } from '../interfaces';

const PopularTopics = ({ filter, isCompact = false }: PopularTopicsProps) => {
  const { trackEvent } = useEventTracking({});

  const handleTopicClick = ({ topic }: { topic: string }) => {
    trackEvent(click({ clickTarget: ClickTarget.Tag, clickText: topic }));
  };

  return (
    <article
      className={clsx('relative mt-24 flex break-inside-avoid flex-col flex-nowrap gap-12', {
        'sm:mt-32': isCompact,
        'sm:mt-0 sm:items-end': !isCompact,
      })}
    >
      <h3 className="m-0 font-suisse-intl-mono text-overline-lg font-normal">Popular topics</h3>
      <div
        className={clsx('flex flex-row flex-wrap', {
          'sm:-mb-8 sm:-mr-8 sm:justify-end': !isCompact,
        })}
      >
        <Pill
          text={ALL}
          href={graphics_path()}
          onClickCapture={() => handleTopicClick({ topic: ALL })}
        />
        <Pill
          aria-label="Filter charts to show Pro Exclusive content only"
          href={graphics_path({ filter: PRO_FILTER })}
          isActive={filter === PRO_FILTER}
          onClickCapture={() => handleTopicClick({ topic: PRO_FILTER_TEXT })}
          text={PRO_FILTER_TEXT}
          data-testid="charts-pro-exclusive-pill"
        />
        {DEFAULT_POPULAR_TOPICS.map((topic) => (
          <Pill
            key={topic}
            text={topic}
            href={graphics_path({ query: topic })}
            onClickCapture={() => handleTopicClick({ topic })}
          />
        ))}
      </div>
    </article>
  );
};

export default PopularTopics;
